import clsx from 'clsx';
import * as React from 'react';
import { clothWeightUnit } from '../../data/materials';
import useDraft from '../hooks/useDraft';
import { useEditor } from '../hooks/useEditor';
import { Material, MaterialKey } from '../types';

export default function MaterialItem({
    materialKey,
    name,
    swatches,
    meta,
    ...rootProps
}: { materialKey: MaterialKey } & Material & any) {
    const {
        editor: { material },
    } = useEditor();
    const { restriction } = useDraft();

    return (
        <div
            {...rootProps}
            className={clsx('material-meta', {
                isSelected: material === materialKey,
            })}
        >
            <div className="meta">
                <div className="name">
                    <span>{name}</span>
                </div>
                <div className="item">{swatches.length} colors</div>
                {meta && meta.weight && (
                    <div className="item">
                        {meta.weight}
                        {clothWeightUnit}
                    </div>
                )}
            </div>
            {restriction && restriction.materials.includes(materialKey) ? (
                <div className="hint">
                    This is the intended material for this template.
                </div>
            ) : null}
        </div>
    );
}
